<template>
  <div class='step5'>
    <a-row type='flex' :gutter='24'>
      <a-col flex='3' style='width: 0'>
<!--        <a-button size='large' type='primary' @click="addCondition()">添加条件</a-button>-->
<!--        <a-card v-if='model.filterList && model.filterList.length>0' size='small'>-->
<!--          <p v-for='(filter, fi) in model.filterList' :key="fi">-->
<!--            <a-space :size='12'>-->
<!--              <a-select v-if='fi > 0' v-model='filter.relation' style='width: 60px'>-->
<!--                <a-select-option value='and'>且</a-select-option>-->
<!--                <a-select-option value='or'>或</a-select-option>-->
<!--              </a-select>-->
<!--              <a-select placeholder='请选择数据源' v-model='filter.field' style='width: 400px'>-->
<!--                <a-select-option :key="fii" v-for="(formItem,fii) in itemList" :value="formItem.name">{{formItem.name}}</a-select-option>-->
<!--              </a-select>-->
<!--              <a-select v-model='filter.con' style='width: 120px'>-->
<!--                <a-select-option value='<'>小于</a-select-option>-->
<!--                <a-select-option value='>'>大于</a-select-option>-->
<!--                <a-select-option value='=='>等于</a-select-option>-->
<!--                <a-select-option value='!='>不等于</a-select-option>-->
<!--                <a-select-option value='<='>小于等于</a-select-option>-->
<!--                <a-select-option value='>='>大于等于</a-select-option>-->
<!--              </a-select>-->
<!--              <a-input v-model='filter.value' style='width: 200px'></a-input>-->
<!--              <a-icon type="close" @click='removeCondition(fi)'/>-->
<!--              <a-icon type="plus-circle" @click='addCondition()'/>-->
<!--            </a-space>-->
<!--          </p>-->
<!--        </a-card>-->
        <a-card>
          <a-row type='flex' :gutter='12'>
            <a-col flex='1' style='width: 0'>
              <a-space :size='12'>
                <label>运算符：</label>
                <a-button size='small' type='text' @click='write'>\n</a-button>
                <a-button size='small' type='text' @click='write'>+</a-button>
                <a-button size='small' type='text' @click='write'>-</a-button>
                <a-button size='small' type='text' @click='write'>*</a-button>
                <a-button size='small' type='text' @click='write'>/</a-button>
                <a-button size='small' type='text' @click='write'>%</a-button>
                <a-button size='small' type='text' @click='write'>(</a-button>
                <a-button size='small' type='text' @click='write'>)</a-button>
                <a-button size='small' type='text' @click='write'>e</a-button>
                <a-button size='small' type='text' @click='write'>^</a-button>
                <a-button size='small' type='text' style="margin-left: 20px" @click='sumAll'>sum(all)</a-button>
                <a-button size='small' type='text' style="margin-left: 5px" @click='strAll'>str()</a-button>
              </a-space>
            </a-col>
            <!--<a-col flex='350px' >-->
              <!--公式是否只解析，不进行计算：-->
              <!--<a-radio-group v-model='model.onlyParse' >-->
                <!--<a-radio value="1">是</a-radio>-->
                <!--<a-radio value="0">否</a-radio>-->
              <!--</a-radio-group>-->
            <!--</a-col>-->
<!--            <a-col flex='60px' >-->
<!--              <a-button size='small' type='primary' @click='editHandle()'>{{!edit ? '编辑' : '确定'}}</a-button>-->
<!--            </a-col>-->
          </a-row>
          <a-divider style='margin: 8px 0'/>
          <a-textarea v-model='model.formula'  :rows="30"></a-textarea>

          <div class='operational-character'>

          </div>
        </a-card>
      </a-col>
      <a-col flex='2' style='width: 0'>
        <a-card>
          <div class='data-source-container-title'>数据源</div>
          <div style="width: 100%;overflow-x: auto">
            <div v-for="(formItem,fii) in itemList" :key="fii" style="margin-top: 10px">
              <!--<div>{{formItem.element.dictItemList}}</div>-->
              <!--字典项元素数据源-->
              <a-space>
                {{(fii+1)}}
                <a-dropdown-button   v-if="formItem.formItem && formItem.formItem.dictItemList&&formItem.formItem.dictItemList.length>0" type='primary' @click='write'>
                  {{formItem.name}}
                  <a-menu slot="overlay">
                    <a-menu-item :key="di" v-for="(dict,di) in formItem.formItem.dictItemList"> {{dict.text}}</a-menu-item>
                  </a-menu>
                  <a-icon slot="icon" type="down" />
                </a-dropdown-button>
                <a-button v-else type="primary" @click='write'>{{formItem.name}}</a-button>
              </a-space>

            </div>

          </div>
        </a-card>
        <a-card>
          <div class='data-source-container-title'>子公式</div>
          <a-button block type="primary" @click='write' v-for="(child,ci) in model.children" :key="ci" style='margin-bottom: 8px'>[{{child.name}}]</a-button>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'Step5',
  components: {  },
  data() {
    return {
      model:{},
      currentEditIndex: null,
      edit:false,
      itemList:[],
    }
  },
  methods: {
    view(model){
      model.filterList = model.filterList || []
      model.formula = model.formula || ''
      model.onlyParse = '0'
      let itemList = []
      if(model.itemList1){
        itemList = itemList.concat(model.itemList1)
      }
      if(model.itemList2){
        itemList = itemList.concat(model.itemList2)
      }
      if(model.itemList3){
        itemList = itemList.concat(model.itemList3)
      }
      this.itemList = itemList
      // console.log("this.itemList:"+ this.itemList)
      this.model = JSON.parse(JSON.stringify(model))
    },

    removeCondition(index) {
      this.model.filterList.splice(index, 1)
    },


    addCondition() {
      this.model.filterList.push({field: '', con: '', value: ''})
    },
    /**
     * 开启公式编辑, 同一时间只能有一个在编辑模式
     * @param item
     */
    editHandle() {
      // todo 需要校验
      this.edit = !this.edit
    },
    /**
     * 第五步  将变量插入/追加到公式内容中
     * @param e
     */
    write(e) {
      let text = e.target.innerText
      if(text==='\\n'){
        text='\n'
      }
      if ( text) {
        this.$set(this.model, 'formula', (this.model.formula||'') + text )
      }
    },
    sumAll(){
      let text = '';
      this.itemList.forEach((item,index)=>{
        text += item.name
        if(index < this.itemList.length-1){
          text+='+\n'
        }
      })
      this.$set(this.model, 'formula', (this.model.formula||'') + text )
    },
    strAll(){
      let text = '';
      this.itemList.forEach((item,index)=>{
        text += '"'+item.name+'"'
        if(index < this.itemList.length-1){
          text+='+\n'
        }
      })
      this.$set(this.model, 'formula', (this.model.formula||'') + text )
    },
    /**
     * 当前步骤表单验证逻辑
     */
    validate() {
      // if(this.edit){
      //   this.$message.warning('请点击公式编辑的“确定”按钮，完成编辑')
      //   return false
      // }
      if(this.model.filterList && this.model.filterList.length>=0){
        let error = false
        this.model.filterList.forEach((item,index)=>{
          if(error){
            return
          }
          if(!item.value || !item.con || !item.field){
            error = true
          }
          if(index>0 &&  !item.relation){
            error = true
          }
        })
        if(error){
          this.$message.warning('请填写完整条件')
          return false
        }
      }
      if(!this.model.formula){
        this.$message.warning('请填写公式')
        return false
      }
      let regex = /\【(.*?)\】/g;
      let match;
      if(!this.itemList){
        this.$message.warning('请选择数据源')
        return false
      }

      while ((match = regex.exec(this.model.formula)) !== null) {
        let dataItem = this.itemList.find(item => item.name === match[0])
        if(!dataItem){
          this.$message.warning('数据源不存在该项数据：'+match[0])
          return false
        }
      }

      let mergeData = []
      if(this.model.children){
        this.model.children.map(i=>mergeData.push(i.name))
      }
      if(this.itemList){
        this.itemList.map(i=>mergeData.push(i.name))
      }

      // regex = /\[(.*?)\]/g;

      // while ((match = regex.exec(this.model.formula)) !== null) {        
      //   let dataItem = mergeData.find(item=>item === match[1] || item === match[0])
      //   if(!dataItem){
      //     this.$message.warning('数据源和子公式不存在该项数据：'+match[0])
      //     return false
      //   }
      // }

      //  可跳过,无需验证
      return true
    }

  }
}
</script>

<style scoped>
.data-source-container-title {
  border-left: 4px solid rgb(34, 144, 255);
  padding-left: 8px;
  font-size: 18px;
  font-weight: bold;
  background: #F8F8F8;
  margin-bottom: 8px;
}

.ant-row-flex .ant-card {
 margin: 20px 0;
}

</style>
